(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["footer-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('footer-navigation')) {
    customElements.define('footer-navigation', class extends HTMLElement {
      connectedCallback() {
        this.disclosure = this.querySelector('[data-footer-quick-links]');
        if (!this.disclosure) return;
        this.trigger = this.disclosure.querySelector('summary');
        this.onEscape = (event) => {
          if (event.key !== 'Escape' || !this.disclosure.open) return;
          event.preventDefault();
          this.disclosure.open = false;
          this.trigger.focus({preventScroll: true});
        };
        this.addEventListener('keydown', this.onEscape);
      }

      disconnectedCallback() {
        this.removeEventListener('keydown', this.onEscape);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tlg-product-tabs')) {
  customElements.define('tlg-product-tabs', class extends HTMLElement {
    connectedCallback() {
      this.links = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('.tab-content')];
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.querySelector('ul').setAttribute('role','tablist');
      this.links.forEach((link,index) => {
        const panel = this.panels[index];
        link.id = this.id + '-tab-' + index;
        panel.id = this.id + '-panel-' + index;
        link.setAttribute('role','tab');
        link.setAttribute('aria-controls',panel.id);
        panel.setAttribute('role','tabpanel');
        panel.setAttribute('aria-labelledby',link.id);
        panel.tabIndex = 0;
        link.addEventListener('click',() => this.activate(index),options);
        link.addEventListener('keydown',event => {
          let next = index;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.links.length) % this.links.length;
          else if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.links.length) % this.links.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.links.length - 1;
          else if (!['Enter',' '].includes(event.key)) return;
          event.preventDefault();
          this.activate(next);
          this.links[next].focus();
        },options);
      });
      this.activate(0);
    }
    disconnectedCallback() { this.controller?.abort(); }
    activate(index) {
      this.links.forEach((link,i) => {
        const active = i === index;
        link.classList.toggle('current',active);
        link.setAttribute('aria-selected',String(active));
        link.tabIndex = active ? 0 : -1;
        this.panels[i].classList.toggle('current',active);
        this.panels[i].hidden = !active;
      });
      this.dispatchEvent(new CustomEvent('theme:form:sticky',{bubbles:true,detail:{element:'tab'}}));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
